import * as t from "io-ts";

// Solid & Gradient

export const ColorTypeV = t.union([
  t.literal("solid"),
  t.literal("linear"),
  t.literal("radial")
]);

export const SolidColorV = t.type({
  value: t.string,
  type: t.literal("solid")
});

export const GradientPointV = t.intersection([
  t.type({
    red: t.number,
    blue: t.number,
    green: t.number,
    alpha: t.number,
    left: t.number
  }),
  t.partial({
    globalColor: t.string
  })
]);

export const GradientColorV = t.type({
  degree: t.number,
  points: t.array(GradientPointV),
  value: t.string,
  svgValue: t.string,
  type: t.union([t.literal("linear"), t.literal("radial")])
});

export const ColorV = t.union([SolidColorV, GradientColorV]);

// Color Input

export const ColorPickerTypeV = t.union([
  t.literal("solidOnly"),
  t.literal("solidAndGradient"),
  t.literal("gradientOnly")
]);

export const ColorOptionsV = t.type({
  type: ColorPickerTypeV
});

export const ColorInputV = t.union([ColorV, t.string, t.null]);

// Global Colors
export const GlobalColorV = t.type({
  cssVariableName: t.string,
  label: t.string,
  value: t.union([t.null, t.string, GradientColorV])
});

export const GlobalColorsV = t.array(GlobalColorV);

export type ColorType = t.TypeOf<typeof ColorTypeV>;
export type GlobalColor = t.TypeOf<typeof GlobalColorV>;
export type Color = t.TypeOf<typeof ColorV>;
export type ColorInputValue = t.TypeOf<typeof ColorInputV>;
export type ColorPickerType = t.TypeOf<typeof ColorPickerTypeV>;
export type ColorOptions = t.TypeOf<typeof ColorOptionsV>;
export type SolidColor = t.TypeOf<typeof SolidColorV>;
export type GradientPoint = t.TypeOf<typeof GradientPointV>;
export type GradientColor = t.TypeOf<typeof GradientColorV>;

// DEFAULTS
export const DEFAULT_RADIAL_GRADIENT: GradientColor = {
  points: [
    {
      left: 0,
      red: 0,
      green: 0,
      blue: 0,
      alpha: 1
    },
    {
      left: 100,
      red: 255,
      green: 0,
      blue: 0,
      alpha: 1
    }
  ],
  type: "radial",
  degree: 0,
  svgValue:
    '<radialGradient id="%%GRADIENTID%%"><stop stop-opacity="1" stop-color="#000000" offset="0"></stop><stop stop-opacity="1" stop-color="#ff0000" offset="1"></stop></radialGradient>',
  value: "radial-gradient(rgba(0, 0, 0, 1) 0%,rgba(255, 0, 0, 1) 100%)"
};

export const DEFAULT_LINEAR_GRADIENT: GradientColor = {
  ...DEFAULT_RADIAL_GRADIENT,
  type: "linear",
  svgValue:
    '<linearGradient x1="0.5" y1="1" x2="0.5" y2="0" id="%%GRADIENTID%%"><stop stop-opacity="1" stop-color="#000000" offset="0"></stop><stop stop-opacity="1" stop-color="#ff0000" offset="1"></stop></linearGradient>',
  value: "linear-gradient(0deg,rgba(0, 0, 0, 1) 0%,rgba(255, 0, 0, 1) 100%)"
};
